import React, { useState } from 'react';
import Input from '../../../components/ui/Input';

import Select from '../../../components/ui/Select';


const SearchBar = ({ searchTerm, onSearch, onSort, sortBy, sortOrder }) => {
  const [localSearchTerm, setLocalSearchTerm] = useState(searchTerm || '');

  const sortOptions = [
    { value: 'created_at', label: 'Date Created' },
    { value: 'first_name', label: 'First Name' },
    { value: 'last_name', label: 'Last Name' },
    { value: 'email', label: 'Email' }
  ];

  const sortOrderOptions = [
    { value: 'asc', label: 'Ascending' },
    { value: 'desc', label: 'Descending' }
  ];

  const handleSearch = () => {
    onSearch?.(localSearchTerm?.trim());
  };

  const handleKeyPress = (e) => {
    if (e?.key === 'Enter') {
      handleSearch();
    }
  };

  const handleClearSearch = () => {
    setLocalSearchTerm('');
    onSearch?.('');
  };

  const handleSortByChange = (value) => {
    onSort?.(value, sortOrder);
  };

  const handleSortOrderChange = (value) => {
    onSort?.(sortBy, value);
  };

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-foreground">Search & Filter</h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <label className="block text-sm font-medium text-blue-100 mb-2">
            Search Talents
          </label>
          <Input
            type="text"
            placeholder="Search by name, email, role, location..."
            value={searchTerm}
            onChange={(e) => onSearch?.(e?.target?.value)}
            className="bg-white bg-opacity-10 border-white border-opacity-30 text-white placeholder-blue-200 rounded-lg"
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium text-blue-100 mb-2">
            Sort By
          </label>
          <Select
            value={sortBy}
            onChange={(e) => onSort?.(e?.target?.value, sortOrder)}
            options={sortOptions}
            className="bg-white bg-opacity-10 border-white border-opacity-30 text-white rounded-lg"
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium text-blue-100 mb-2">
            Order
          </label>
          <Select
            value={sortOrder}
            onChange={(e) => onSort?.(sortBy, e?.target?.value)}
            options={sortOrderOptions}
            className="bg-white bg-opacity-10 border-white border-opacity-30 text-white rounded-lg"
          />
        </div>
      </div>
    </div>
  );
};

export default SearchBar;